const tokenKey = 'waitingRoomToken'
let currentToken = null
const validToken = token => typeof token === 'string' && token.length > 0 && token.length <= 256 && /^[A-Za-z0-9._-]+$/.test(token)

// This is a server-signed bearer credential, not a client-side admission flag.
// Redis membership and expiry are still verified by the backend on purchase.
export function waitingRoomHeaders() {
  try {
    const stored = sessionStorage.getItem(tokenKey)
    if (validToken(stored)) currentToken = stored
    else if (stored) currentToken = null
  } catch (error) { /* A current tab can continue when storage is unavailable. */ }

  return currentToken ? { 'X-Waiting-Room-Token': currentToken } : {}
}

export function rememberWaitingRoomSession(data) {
  if (!data || !validToken(data.waitingRoomToken)) return
  currentToken = data.waitingRoomToken
  try { sessionStorage.setItem(tokenKey, currentToken) } catch (error) { /* Cookie/in-memory fallback. */ }
}

export function clearWaitingRoomSession() {
  currentToken = null
  try { sessionStorage.removeItem(tokenKey) } catch (error) { /* Optional storage. */ }
}

export function waitingRoomErrorCode(value) {
  const payload = value && value.response ? value.response.data : value
  const network = payload && payload.networkError && payload.networkError.result
  // Apollo puts the body of a non-2xx response on networkError.result.
  const errors = [payload && (payload.errors || payload.graphQLErrors), network && network.errors]
    .flatMap(list => Array.isArray(list) ? list : [])
  const failure = errors.find(error => error.extensions &&
    ['WAITING_ROOM_REQUIRED', 'WAITING_ROOM_UNAVAILABLE', 'WAITING_ROOM_CREDENTIAL_INVALID'].includes(error.extensions.code))

  return failure ? failure.extensions.code : null
}
